function filterShopifyEvent(event, domElement, callback) {
    let executeCallback = false;
    if (event.type.includes('shopify:section')) {
        if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) executeCallback = true;
    } else if (event.type.includes('shopify:block') && event.target === domElement) {
        executeCallback = true;
    }
    if (executeCallback) callback(event);
}

function inViewport(elem, callback, options = {}) {
    return new IntersectionObserver(entries => {
        entries.forEach(entry => callback(entry));
    }, options).observe(document.querySelector(elem));
}

let toggleBodyClass = function(arg) {
    document.body.classList.toggle(arg);
}

function getElementHeight(targetElement, appendTo, cssVar) {
    let element = document.querySelector(targetElement);
    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

const getSetVh = () => {
    const roundedVh = Math.round(window.innerHeight * 0.01);
    document.body.style.setProperty('--vh', `${roundedVh}px`);
};
window.addEventListener('resize', getSetVh);

function getNavigator() {
    const isiOS = navigator.userAgent.match(/(iPhone|iPad|iPod)/) && navigator.userAgent.match(/AppleWebKit/) && !navigator.userAgent.match(/CriOS/);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) || navigator.userAgent.indexOf('Chrome') != -1;
    const isFirefox = typeof InstallTrigger !== 'undefined' || navigator.userAgent.indexOf('Firefox') != -1;
    const isEdge = !!window.StyleMedia || navigator.userAgent.indexOf('Edge') != -1;

    if (isiOS) document.documentElement.classList.add('ios');
    if (isSafari) document.documentElement.classList.add('safari');
    if (isChrome) document.documentElement.classList.add('chrome');
    if (isFirefox) document.documentElement.classList.add('firefox');
    if (isEdge) document.documentElement.classList.add('edge');
}

let toggleClass = function(qSelectors, bodyClass) {
    document.querySelectorAll(qSelectors).forEach(e => e.addEventListener('click', () => toggleBodyClass(bodyClass)));
}
let toggleMenu = function() {
    toggleClass('.fire-menu, .shrink-menu', 'open-menu');
}

function initializeDetailsControls() {
    const detailsElementsLv1 = document.querySelectorAll('details.lv1');
    const detailsElementsClosex = [...document.querySelectorAll('details.closex')];

    function closeOtherDetails(element) {
        const detailsOpened = document.querySelectorAll('details[open].lv1');
        for (const item of detailsOpened) {
            if (element !== item) {
                item.removeAttribute('open');
            }
        }
    }

    function closeAllDetailsExcept(target) {
        detailsElementsClosex.forEach(f => !f.contains(target) ? f.removeAttribute('open') : '');
        a11yDetails();
    }

    function closeAllDetails() {
        detailsElementsClosex.forEach(f => f.removeAttribute('open'));
        a11yDetails();
    }

    detailsElementsLv1.forEach(item => {
        item.addEventListener('click', function() {
            closeOtherDetails(this);
        });
    });

    document.addEventListener('click', function(e) {
        if (!detailsElementsClosex.some(f => f.contains(e.target))) {
            closeAllDetails();
        } else {
            closeAllDetailsExcept(e.target);
        }
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            closeAllDetails();
        }
    });

    a11yDetails();
}

function a11yDetails() {
    document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
        summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
        if (summary.nextElementSibling.getAttribute('id')) {
            summary.setAttribute('aria-controls', summary.nextElementSibling.id);
        }
        summary.addEventListener('click', (event) => {
            event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        });
    });
}

function updatePrice(obj, idd) {
    var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
    var pb = document.querySelector('.uprice' + idd);
    pb.innerHTML = uid;
}

function selectOptions(obj, idd) {
    updatePrice(obj, idd);
}

if (window.location.href.includes('debug')) {
    const OpenThinking = { theme: { name: 'Bullet', version: Shopify.theme.schema_version } };
    const tsiCheck = (Shopify.theme.theme_store_id === null || Shopify.theme.theme_store_id === '') ? '❌' : '✅';
    console.log(`${tsiCheck} ${OpenThinking.theme.name} v${OpenThinking.theme.version} - ${Shopify.shop}`);
    alert(`${tsiCheck} ${OpenThinking.theme.name} v${OpenThinking.theme.version} `);
}

if (!customElements.get('bullet-marquee')) customElements.define('bullet-marquee', class bulletMarquee extends HTMLElement {
    constructor() {
        super();
        if (window.ResizeObserver) new ResizeObserver(this.duration.bind(this)).observe(this);
    }

    duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute('bullet-speed') || 5);
        const contentWidth = entries[0].contentRect.width;
        let slowFactor = contentWidth <= 375 ? 1 : contentWidth >= 1280 ? 3 : 1 + (contentWidth - 375) / (1280 - 375);
        const scrollingDuration = (scrollingSpeed * slowFactor * entries[0].target.querySelector('span').clientWidth / contentWidth).toFixed(3);
        this.style.setProperty('--bullet-speed', `${scrollingDuration}s`);
    }
});

const dh = document.querySelector('.drawer-hamburger');
if (dh) {
    dh.addEventListener('click', () => {
        document.body.classList.toggle('menu-active');
    });
}
const dno = document.querySelector('.drawer-nav-overlay');
if (dno) {
    dno.addEventListener('click', () => {
        document.body.classList.remove('menu-active');
    });
}

/*** HEADER OVERLAY ***/
let __headerObserver;
let __heroResizeObs;
let __headerResizeObs;

function resolveHero() {
    return document.querySelector('[data-header-overlay]') ||
        document.querySelector('#MainContent .shopify-section img, video, picture, .slideshow, .banner, .hero, .image-banner')?.closest('.shopify-section, section') ||
        document.querySelector('#MainContent .shopify-section');
}

function setHeaderMode(onHero) {
    const header =
        document.querySelector('header.header') ||
        document.querySelector('.shopify-section-header') ||
        document.querySelector('header');
    if (!header) return;
    if (onHero) {
        header.classList.add('header--on-hero');
        header.classList.remove('header--scrolled');
    } else {
        header.classList.remove('header--on-hero');
        header.classList.add('header--scrolled');
    }
}

function buildObserver(hero) {
    const header =
        document.querySelector('header.header') ||
        document.querySelector('.shopify-section-header') ||
        document.querySelector('header');
    if (!header || !hero) return;

    const headerHeight = header.offsetHeight || 0;

    if (!__headerObserver) {
        __headerObserver = new IntersectionObserver(entries => {
            const entry = entries[0];
            setHeaderMode(entry && entry.isIntersecting);
        }, {
            root: null,
            rootMargin: `-${Math.max(0, headerHeight - 1)}px 0px 0px 0px`,
            threshold: 0
        });
    }

    __headerObserver.observe(hero);

    if ('ResizeObserver' in window) {
        if (!__heroResizeObs) {
            __heroResizeObs = new ResizeObserver(() => {
                __headerObserver.unobserve(hero);
                __headerObserver.observe(hero);
            });
            __heroResizeObs.observe(hero);
        }

        if (!__headerResizeObs) {
            __headerResizeObs = new ResizeObserver(() => {
                __headerObserver.unobserve(hero);
                __headerObserver.observe(hero);
            });
            __headerResizeObs.observe(header);
        }
    }
}

function initHeaderOverlay() {
    setHeaderMode(false);
    const hero = resolveHero();
    if (!hero) return;
    buildObserver(hero);
}

[
    'shopify:section:load',
    'shopify:section:unload',
    'shopify:section:select',
    'shopify:section:deselect',
    'shopify:block:select',
    'shopify:block:deselect',
    'shopify:section:reorder'
].forEach(function(evt) {
    document.addEventListener(evt, function(e) {
        if (!e || !e.target || !e.target.closest || !e.target.closest('#MainContent')) return;
        initHeaderOverlay();
    });
});

document.addEventListener('load', function(e) {
    var t = e.target;
    if (t && (t.tagName === 'IMG' || t.tagName === 'VIDEO' || t.tagName === 'PICTURE')) {
        initHeaderOverlay();
    }
}, true);

// 👇 MODIFICADO: resize con debounce
let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        initHeaderOverlay();
    }, 100);
});

/*** init app */
function app() {
    getSetVh();
    getNavigator();
    toggleMenu();
    initializeDetailsControls();
}

document.addEventListener("DOMContentLoaded", () => {
    app();
    initHeaderOverlay();
});

